// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__KCoow","spinner-cover-container":"Spinner_spinner-cover-container__R_-Zx","spinner-cover-background":"Spinner_spinner-cover-background__rgJx7"};